import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Partner} from '../../../shared/interface/partner';
import {Observable, ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {PartnerService} from '../../../shared/services/partner.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AuthService} from '../../../shared/services/auth.service';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {Dictionary} from '../../../shared/interface/dictionary';
import {
  COMPANY_ASF, COMPANY_ASF_PREMIUM,
  CONTRACT_STATUS_ACTIVE, CONTRACT_STATUS_DURING_TERMINATION,
  CONTRACT_STATUS_NEW, CONTRACT_STATUS_SENT_WITH_AUTENTI, CONTRACT_STATUS_TERMINATED, CONTRACT_STATUS_TO_TERMINATE, CONTRACT_TYPE_OCK,
  CONTRACT_TYPE_PARTNERSHIP, CONTRACT_TYPE_SELF_BILLING,
  DICT_TYPE_TEMPLATE_TYPE,
  DictService, LEGAL_FORM_LEGAL_PERSON, LEGAL_FORM_NATURAL_PERSON,
  PARTNER_TAGS_PROFIT,
  TEMPLATE_TYPE_PARTNER_DATA,
  TEMPLATE_TYPE_STATEMENT
} from '../../../shared/services/dict.service';
import {ChangeRegionalDialogComponent} from '../change-regional-dialog/change-regional-dialog.component';
import {UpdateCurrentDynamicsDialogComponent} from "../update-current-dynamics-dialog/update-current-dynamics-dialog.component";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {TemplateService} from "../../../shared/services/template.service";
import {
  ChangeAccountNumberDialogComponent
} from "../change-account-number-dialog/change-account-number-dialog.component";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {Contract} from "../../../shared/interface/contract";
import {OckAddComponent} from "../ock-add/ock-add.component";
import {PartnerOckAccount} from "../../../shared/interface/partner-ock-account";
import {CommissionSettlementService} from "../../../shared/services/commission-settlement.service";

@Component({
  selector: 'app-partner-details-view',
  templateUrl: './partner-details-view.component.html',
  styleUrls: ['./partner-details-view.component.scss']
})
export class PartnerDetailsViewComponent implements OnInit, OnDestroy {
  @Input() partner: Observable<Partner>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() partnerChanged = new EventEmitter<any>();

  partnerObject?: Partner;
  userPermissions: ReplaySubject<UserPermissions>;
  profitPartner = false;
  generatingDocument = false;
  hidePartner = false;
  contractAsf = false;
  hasContractOckActive = false;
  userPermissionss: UserPermissions;
  contractPremium = false;
  errors: any = {};
  partnerOCKAccounts: PartnerOckAccount[];
  readonly LEGAL_FORM_NATURAL_PERSON = LEGAL_FORM_NATURAL_PERSON;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private partnerService: PartnerService,
    private commissionSettlementService: CommissionSettlementService,
    private snack: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private auth: AuthService,
    private dictService: DictService,
    private templateService: TemplateService,

  ) {
    this.userPermissions = this.auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
      });
    this.partner
      .pipe(takeUntil(this.destroyed$))
      .subscribe((partner: Partner) => {
        this.partnerObject = partner;
        this.partnerOCKAccounts = [...this.partnerObject.partnerOCKAccounts].sort((a, b) => {
          return a.owner === b.owner ? 0 : a.owner ? -1 : 1;
        });
        this.partnerObject.tags.forEach((tag: Dictionary) => {
          if (tag.key === PARTNER_TAGS_PROFIT) {
            this.profitPartner = true;
          }
        });
        if (this.userPermissionss.contract.read) {
          this.partnerService.getPartnerContracts(this.partnerObject.uuid)
            .subscribe((contracts: ListResponse<Contract>) => {
              contracts.items.forEach((contract: Contract) => {
                if (contract.type.key === CONTRACT_TYPE_PARTNERSHIP && contract.company.key === COMPANY_ASF &&
                  (contract.status.key === CONTRACT_STATUS_NEW || contract.status.key === CONTRACT_STATUS_SENT_WITH_AUTENTI ||
                    contract.status.key === CONTRACT_STATUS_ACTIVE)) {
                  this.contractAsf = true;
                }
                if (contract.type.key === CONTRACT_TYPE_PARTNERSHIP && contract.company.key === COMPANY_ASF_PREMIUM &&
                  (contract.status.key === CONTRACT_STATUS_NEW || contract.status.key === CONTRACT_STATUS_SENT_WITH_AUTENTI ||
                    contract.status.key === CONTRACT_STATUS_ACTIVE)) {
                  this.contractPremium = true;
                }
                if (contract.type.key === CONTRACT_TYPE_OCK && contract.status.key === CONTRACT_STATUS_ACTIVE){
                  this.hasContractOckActive = true;
                }
              });
            });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć partnera?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.partnerService.deletePartner(this.partnerObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto partnera', '', {duration: 2000});
            this.router.navigate(['/partnerzy']);
          }, (error: HttpErrorResponse) => {
              if (error.status === 400) {
                this.snack.open(error.error.error.text, '400', {duration: 4000});
              }
            });
      }
    });
  }

  changeRegional(): void {
    const dialogRef = this.dialog.open(ChangeRegionalDialogComponent, {
      width: '700px',
      data: {partnerObject: this.partnerObject},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.partnerChanged.emit();
    });
  }

  changeCurrentDynamics(): void {
    const dialogRef = this.dialog.open(UpdateCurrentDynamicsDialogComponent, {
      width: '700px',
      data: {partnerObject: this.partnerObject},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.partnerChanged.emit();
    });
  }



  accountNumber(): void {
    const dialogRef = this.dialog.open(ChangeAccountNumberDialogComponent, {
      width: '700px',
      data: {partnerObject: this.partnerObject},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.partnerChanged.emit();
    });
  }

  generatePartnerDataDocuments(): void {
    this.generatingDocument = true;
    this.dictService.getId(TEMPLATE_TYPE_PARTNER_DATA, DICT_TYPE_TEMPLATE_TYPE)
      .subscribe((dictId: number) => {
        this.templateService.generate({
          type: dictId,
          partner: this.partnerObject.uuid,
        }).subscribe((response: Uuid) => {
          const dialogRef = this.dialog.open(JobResultDialogComponent, {
            disableClose: true,
            width: '500px',
            data: {jobId: response.uuid, showProgress: false},
          });

          dialogRef.afterClosed().subscribe(() => {
            this.generatingDocument = false;
          });
        }, (error: HttpErrorResponse) => {
          this.generatingDocument = false;
          if (error.status === 404) {
            this.snack.open('Brak szablonów dla tego typu dokumentu', '', {duration: 2000});
            return;
          }

          this.snack.open('Przy generowaniu dokumentów wystąpił błąd', error.status.toString(), {duration: 2000});
        });
      });
  }

  createOCKAccount(): void {
    const dialogRef = this.dialog.open(OckAddComponent, {
      width: '70%',
      data: {partnerObject: this.partnerObject, addUserAccount: false},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.partnerChanged.emit();
    });
  }

  editOCKAccount(partnerOckAccount: PartnerOckAccount): void {
    this.partnerService.editOCKAccount(partnerOckAccount.uuid)
      .subscribe({
        next: () => {
          this.snack.open(partnerOckAccount.active ? 'Konto zablokowane' : 'Konto aktywne', '', { duration: 2000 });
          this.partnerChanged.emit();
        },
        error: (error: HttpErrorResponse) => {
          console.error(error);
          const errorMessage = error.error?.error || 'Podczas aktualizacji konta wystąpił błąd';
          const errorStatus = error.status ?? '500';

          this.snack.open(errorMessage, `${errorStatus}`, { duration: 3000 });

          if (errorStatus === 400 && error.error?.error) {
            this.errors = error.error?.error;
          }
        }
      });
  }

  addUserOckAccount(): void {
    const dialogRef = this.dialog.open(OckAddComponent, {
      width: '70%',
      data: {partnerObject: this.partnerObject, addUserAccount: true},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.partnerChanged.emit();
    });
  }

  sendPassword(uuid: string): void {
    this.partnerService.sendPassword(uuid)
      .subscribe((response) => {
        this.snack.open('Hasło zostało wysłane',  '', {duration: 2000});
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy wysyłąniu hasła wystąpił błąd', error.status.toString(), {duration: 2000});
        if (error.status === 400) {
          this.snack.open(error.error.error.text, '400', {duration: 4000});
        }
      });

  }

  sendInvitation(uuid: string): void {
    this.partnerService.sendInvitation(uuid)
      .subscribe((response) => {
        this.snack.open('Link do rejestracji został wysłany',  '', {duration: 2000});
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy wysyłąniu hasła wystąpił błąd', error.status.toString(), {duration: 2000});
        if (error.status === 400) {
          this.snack.open(error.error.error.text, '400', {duration: 4000});
        }
      });

  }

  hasAnyDate(): boolean {
    const p = this.partnerObject;
    const dateFields = [
      p.startDate,
      p.endDate,
      p.dateOfSuspension,
      p.resumptionDate,
      p.deletionRegonData,
      p.judgmentDeclaringDate,
      p.completionBankruptcyProceedingDate,
      p.deletionRegistryData
    ];

    return dateFields.some(date => date !== null && date !== undefined);
  }

}
